import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import {
  TICKET_STATUS_OPTIONS,
  TICKET_PRIORITY_OPTIONS,
  TICKET_CATEGORY_OPTIONS,
} from "../options";

/**
 * Status Fields
 * Ticket status, priority, and category fields.
 *
 * `savedViewMembership` mirrors `../saved-views/ticket-saved-views.ts`.
 */
export const statusFields = defineFieldConfigMap({
  // FIELD: status
  status: {
    type: "select",
    label: "Status",
    isStatusField: true,
    formSpan: 1,
    options: TICKET_STATUS_OPTIONS.map((option) => ({
      label: option.label,
      value: option.value,
    })),
    validation: {
      required: false,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    filterType: "exact",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    icon: "CheckCircle",
    groupable: true,
    // Clients track the status of their own tickets.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "status",
    graphqlSelector: "status",
    savedViewMembership: [
      "all-tickets",
      "my-tickets",
      "high-priority",
      "open-tickets",
      "overdue-tickets",
      "resolved-tickets",
      "no-time-entries",
      "with-time-entries",
    ],
  },

  // FIELD: priority
  priority: {
    type: "select",
    label: "Priority",
    formSpan: 1,
    options: TICKET_PRIORITY_OPTIONS.map((option) => ({
      label: option.label,
      value: option.value,
    })),
    validation: {
      required: false,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    filterType: "exact",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "AlertTriangle",
    groupable: true,
    // Clients see their ticket's priority.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "status",
    graphqlSelector: "priority",
    savedViewMembership: [
      "all-tickets",
      "my-tickets",
      "high-priority",
      "open-tickets",
      "overdue-tickets",
      "resolved-tickets",
      "no-time-entries",
      "with-time-entries",
    ],
  },

  // FIELD: category
  category: {
    type: "select",
    label: "Category",
    formSpan: 1,
    options: TICKET_CATEGORY_OPTIONS.map((option) => ({
      label: option.label,
      value: option.value,
    })),
    validation: {
      required: false,
    },
    // Table properties
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    filterType: "exact",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Tag",
    // Clients see their ticket's category.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "status",
    graphqlSelector: "category",
    savedViewMembership: ["all-tickets"],
  },
});
